import type { RelationshipsLink, RelationshipsLinkVisual } from './types';

export const enrichToVisualLinks = (
  raw: RelationshipsLink[] | null,
  links: RelationshipsLinkVisual[]
): RelationshipsLinkVisual[] | null => {
  if (!raw?.length) return null;
  const matchedModelIds = new Set(raw.map(link => link.modelId));
  return links.filter(link =>
    link.modelIds.some(id => matchedModelIds.has(id))
  );
};
